export const DISCOVERY_CANDIDATES_QUERY = "onboarding.discovery.v1";
/**
 * The live view behind the `onboarding.discovery.v1` seam
 * (`client/rpc/src/onboarding/discovery-contract.ts`). `requiresDurableStorage: false`:
 * `DiscoveryProbeService.snapshot()` is in-memory plus a home-node HTTP round trip, never
 * the OPFS-backed local SQLite cache, so onboarding discovery keeps working even before that
 * cache exists — the device isn't claimed yet at this step (#1661's rationale applies here
 * too, see `owner-views.ts`).
 */
export function createDiscoveryCandidatesQuery(service) {
    return {
        invalidateOn: ["domain.entity-changed"],
        key: (row) => row.address,
        name: DISCOVERY_CANDIDATES_QUERY,
        requiresDurableStorage: false,
        run: async (params) => {
            parseEmptyParams(params);
            return service.snapshot();
        },
    };
}
function parseEmptyParams(value) {
    if (value === null || typeof value !== "object" || Array.isArray(value) || Object.keys(value).length !== 0) {
        throw new TypeError("Onboarding discovery query does not accept parameters");
    }
}
//# sourceMappingURL=discovery.js.map